//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconFileRemove(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M15.41 2L20 6.59V8H14V4H6V20H18V10H20V22H4V2H15.41Z" fill="currentColor" /><path d="M16 13V15H8V13H16Z" fill="currentColor" /></svg>;
}
export default IconFileRemove;